/* eslint-disable @bigbinary/neeto/use-neetoui-classes */
import { Badge } from "@bigbinary/neeto-atoms";
import {
  SidebarMenuSubItem,
  SidebarMenuSubButton,
} from "@bigbinary/neeto-atoms/primitives";
import classnames from "classnames";
import { hyphenate } from "neetocist";
import { Segments } from "neetofilters";
import { is } from "ramda";
import { useLocation } from "react-router-dom";

import CheckPointNavLinks from "./CheckPointNavLink";

import { SUB_LINK_TYPES } from "../constants";
import { isSubRouteActive } from "../utils";

const SubLinkItem = ({
  to,
  href,
  onClick,
  label,
  className,
  type = SUB_LINK_TYPES.SYSTEM_VIEW,
  count,
  isSectionHeader,
  isCountsLoading,
  "data-testid": dataTestid,
  entity = "",
  columns = [],
  baseUrl,
  isActive,
  tag,
}) => {
  const location = useLocation();

  if (type === SUB_LINK_TYPES.SEGMENTS) {
    return <Segments {...{ baseUrl, columns, entity }} isIndependent={false} />;
  }

  const dataTestidPrefix = dataTestid || hyphenate(label);

  const renderCount = count => (count > 999 ? "999+" : count);

  const isSubLinkActive = () =>
    !isSectionHeader &&
    (is(Function, isActive) ? isActive() : isSubRouteActive(to, location));

  return (
    <SidebarMenuSubItem>
      <SidebarMenuSubButton
        asChild
        isActive={isSubLinkActive()}
        size="md"
        className={classnames(
          "h-auto overflow-visible py-1.5 whitespace-normal",
          className
        )}
      >
        <CheckPointNavLinks
          {...{ href, onClick, to }}
          activeClassName="active"
          data-testid={`${dataTestidPrefix}-sub-link`}
          isActive={isSubLinkActive}
        >
          <span
            className="flex flex-grow items-center gap-2"
            data-testid={`${dataTestidPrefix}-sub-link-label`}
          >
            {label}
            {tag && <Badge {...tag} />}
          </span>
          <span
            className="text-sidebar-foreground/70 flex-shrink-0 text-xs"
            data-testid={`${dataTestidPrefix}-sub-link-count`}
          >
            {isCountsLoading ? (
              <div className="bg-sidebar-accent h-4 w-4 animate-pulse rounded" />
            ) : (
              renderCount(count)
            )}
          </span>
        </CheckPointNavLinks>
      </SidebarMenuSubButton>
    </SidebarMenuSubItem>
  );
};

export default SubLinkItem;
